/* Karim Portfolio — shared behaviour for the Shopify sections.
   Content that used to live in JS arrays (projects, testimonials) now comes
   from section settings/blocks and is rendered in Liquid. */
(function () {
  "use strict";

  /* ---- burger (header section) ---- */
  function initBurger(root) {
    root.querySelectorAll("[data-kp-burger]").forEach(function (burger) {
      if (burger.dataset.kpBound) return;
      burger.dataset.kpBound = "1";
      var nav = burger.closest(".kp").querySelector("[data-kp-navlinks]");
      if (!nav) return;
      burger.addEventListener("click", function () {
        nav.classList.toggle("open");
        burger.classList.toggle("open");
      });
    });
  }

  /* ---- reveal on scroll ---- */
  var io = null;
  function initReveals(root) {
    if (!("IntersectionObserver" in window)) {
      root.querySelectorAll(".rv").forEach(function (el) { el.classList.add("in"); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
    }
    root.querySelectorAll(".rv:not(.in)").forEach(function (el) { io.observe(el); });
  }

  /* ---- contact -> whatsapp (contact section) ---- */
  function initContact(root) {
    root.querySelectorAll("[data-kp-contact]").forEach(function (card) {
      var btn = card.querySelector("[data-kp-send]");
      var msg = card.querySelector("[data-kp-msg]");
      if (!btn || !msg || btn.dataset.kpBound) return;
      btn.dataset.kpBound = "1";

      var number = (btn.getAttribute("data-wa-number") || "").replace(/[^\d]/g, "");
      var fallback = btn.getAttribute("data-wa") || "#";
      var prefix = btn.getAttribute("data-wa-prefix") || "";

      btn.addEventListener("click", function () {
        var typed = msg.value.trim();

        // Nothing typed → nudge the visitor instead of sending an empty message.
        if (!typed) {
          msg.focus();
          card.classList.add("kp-shake");
          setTimeout(function () { card.classList.remove("kp-shake"); }, 500);
          return;
        }

        var url;
        if (number) {
          // Send the typed text straight into the chat.
          var text = prefix ? prefix + "\n\n" + typed : typed;
          url = "https://wa.me/" + number + "?text=" + encodeURIComponent(text);
        } else {
          // No number configured: fall back to the plain link (e.g. a wa.link
          // short link, which cannot carry a ?text parameter) and copy the text
          // so the visitor can paste it.
          url = fallback;
          if (navigator.clipboard) {
            navigator.clipboard.writeText(typed).then(function () {
              var cs = card.querySelector(".contact-small");
              if (cs) cs.textContent = btn.getAttribute("data-copied") || cs.textContent;
            }, function () {});
          }
        }
        window.open(url, "_blank");
      });

      msg.addEventListener("keydown", function (e) {
        if (e.key === "Enter") { e.preventDefault(); btn.click(); }
      });
    });
  }

  /* ---- project carousel arrows (work / related sections) ---- */
  function initCarousels(root) {
    root.querySelectorAll("[data-kp-carousel]").forEach(function (wrapper) {
      if (wrapper.dataset.kpBound) return;
      wrapper.dataset.kpBound = "1";
      var sc = wrapper.querySelector("[data-kp-scroll]");
      var prev = wrapper.querySelector("[data-kp-prev]");
      var next = wrapper.querySelector("[data-kp-next]");
      if (!sc || !prev || !next) return;
      function step() {
        var card = sc.querySelector(".pcard");
        return (card ? card.offsetWidth : 420) + 24;
      }
      prev.addEventListener("click", function () { sc.scrollBy({ left: -step(), behavior: "smooth" }); });
      next.addEventListener("click", function () { sc.scrollBy({ left: step(), behavior: "smooth" }); });
      function edges() {
        prev.disabled = sc.scrollLeft <= 4;
        next.disabled = sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 4;
      }
      sc.addEventListener("scroll", edges, { passive: true });
      window.addEventListener("resize", edges);
      setTimeout(edges, 100);
    });
  }

  /* ---- platform badge filters above the project carousel ---- */
  function initFilters(root) {
    root.querySelectorAll("[data-kp-filters]").forEach(function (bar) {
      if (bar.dataset.kpBound) return;
      bar.dataset.kpBound = "1";

      var wrap = bar.closest("[data-kp-carousel]") || bar.parentNode;
      var scroll = wrap.querySelector("[data-kp-scroll]");
      var empty = wrap.querySelector("[data-kp-empty]");
      if (!scroll) return;

      var buttons = bar.querySelectorAll("[data-kp-filter]");

      bar.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-kp-filter]");
        if (!btn) return;

        var want = btn.getAttribute("data-kp-filter");
        buttons.forEach(function (b) { b.classList.toggle("is-active", b === btn); });

        var shown = 0;
        scroll.querySelectorAll(".pcard").forEach(function (card) {
          var match = want === "all" || card.getAttribute("data-platform") === want;
          card.hidden = !match;
          if (match) shown++;
        });

        if (empty) empty.hidden = shown > 0;
        scroll.scrollTo({ left: 0, behavior: "smooth" });
      });
    });
  }

  /* ---- manually scrollable review strip (drag / swipe / arrows) ---- */
  function initDragScroll(root) {
    root.querySelectorAll("[data-kp-drag]").forEach(function (strip) {
      if (strip.dataset.kpBound) return;
      strip.dataset.kpBound = "1";

      /* --- click-and-drag with the mouse. Touch uses native scrolling. --- */
      var down = false, startX = 0, startLeft = 0, moved = 0;

      strip.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "touch") return; // let the browser handle touch
        down = true;
        moved = 0;
        startX = e.clientX;
        startLeft = strip.scrollLeft;
      });

      strip.addEventListener("pointermove", function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4 && !strip.classList.contains("is-dragging")) {
          strip.classList.add("is-dragging");
          if (strip.setPointerCapture) { try { strip.setPointerCapture(e.pointerId); } catch (err) {} }
        }
        if (strip.classList.contains("is-dragging")) {
          moved = Math.abs(dx);
          strip.scrollLeft = startLeft - dx;
          e.preventDefault();
        }
      });

      function endDrag() {
        down = false;
        strip.classList.remove("is-dragging");
      }
      strip.addEventListener("pointerup", endDrag);
      strip.addEventListener("pointercancel", endDrag);
      strip.addEventListener("pointerleave", endDrag);

      /* a drag must not trigger the link/image underneath */
      strip.addEventListener("click", function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      /* --- arrows --- */
      var section = strip.closest(".kp") || root;
      var arrows = section.querySelector("[data-kp-drag-arrows]");
      if (arrows) {
        var prev = arrows.querySelector("[data-kp-drag-prev]");
        var next = arrows.querySelector("[data-kp-drag-next]");

        function step() {
          var card = strip.querySelector(".t-img, .t-ph");
          return (card ? card.offsetWidth : 220) + 20; // + the 20px gap
        }
        function edges() {
          if (prev) prev.disabled = strip.scrollLeft <= 4;
          if (next) next.disabled = strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 4;
        }
        if (prev) prev.addEventListener("click", function () {
          strip.scrollBy({ left: -step(), behavior: "smooth" });
        });
        if (next) next.addEventListener("click", function () {
          strip.scrollBy({ left: step(), behavior: "smooth" });
        });
        strip.addEventListener("scroll", edges, { passive: true });
        window.addEventListener("resize", edges);
        setTimeout(edges, 100);
      }

      /* --- keyboard, once the strip is focused --- */
      strip.addEventListener("keydown", function (e) {
        var card = strip.querySelector(".t-img, .t-ph");
        var d = (card ? card.offsetWidth : 220) + 20;
        if (e.key === "ArrowLeft") { strip.scrollBy({ left: -d, behavior: "smooth" }); e.preventDefault(); }
        if (e.key === "ArrowRight") { strip.scrollBy({ left: d, behavior: "smooth" }); e.preventDefault(); }
      });
    });
  }

  /* ---- current year in the footer ---- */
  function initYear(root) {
    root.querySelectorAll("[data-kp-year]").forEach(function (el) {
      el.textContent = new Date().getFullYear();
    });
  }

  function init(root) {
    root = root || document;
    initBurger(root);
    initReveals(root);
    initContact(root);
    initCarousels(root);
    initFilters(root);
    initDragScroll(root);
    initYear(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }

  /* re-init when a section is added/re-rendered in the theme editor */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:section:select", function (e) { init(e.target); });
})();
